import React, { Suspense, lazy } from "react";
import TestLoader from "../../pages/testing/TestLoader/TestLoader";
import { ECLLoader } from "../../eclComponents";
import { translate } from "../../utilities/Translate";
import { Route } from "react-router-dom";

//TESTING PAGES
//TestLoader includes the Suspense component so all of the children placed inside need to be lazy imports
const TestingPanelHome = lazy(
   () => import("../../pages/testing/TestingPanelHome"),
);
const ECLLoaderTest = lazy(
   () => import("../../pages/testing/ECLLoaderTest/ECLLoaderTest"),
);
const ECLTextInputTest = lazy(
   () => import("../../pages/testing/ECLTextInputTest/ECLTextInputTest"),
);
const ECLUserInfoTest = lazy(
   () => import("../../pages/testing/ECLUserInfoTest/ECLUserInfoTest"),
);
const ECLFeatureFlagTest = lazy(
   () => import("../../pages/testing/ECLFeatureFlagTest/ECLFeatureFlagTest"),
);
const ECLToastTest = lazy(
   () => import("../../pages/testing/ECLToastTest/ECLToastTest"),
);
const ECLThemeImageTest = lazy(
   () => import("../../pages/testing/ECLThemeImageTest/ECLThemeImageTest"),
);
const ECLRichTextViewerTest = lazy(
   () =>
      import("../../pages/testing/ECLRichTextViewerTest/ECLRichTextViewerTest"),
);
const ECLDatePickerTest = lazy(
   () => import("../../pages/testing/ECLDatePickerTest/ECLDatePickerTest"),
);
const ECLTableTest = lazy(
   () => import("../../pages/testing/ECLTableTest/ECLTableTest"),
);
const ECLDropDownTest = lazy(
   () => import("../../pages/testing/ECLDropDownTest/ECLDropDownTest"),
);
const ECLCheckBoxTest = lazy(
   () => import("../../pages/testing/ECLCheckBoxTest/ECLCheckBoxTest"),
);
const ECLSwtichTest = lazy(
   () => import("../../pages/testing/ECLSwitchTest/ECLSwitchTest"),
);
const ECLFileInputTest = lazy(
   () => import("../../pages/testing/ECLFileInputTest/ECLFileInputTest"),
);
const ECLDateTimePickerTest = lazy(
   () =>
      import("../../pages/testing/ECLDateTimePickerTest/ECLDateTimePickerTest"),
);
const ECLFilterBarTest = lazy(
   () => import("../../pages/testing/ECLFilterBarTest/ECLFilterBarTest"),
);
const ECLPasswordTest = lazy(
   () => import("../../pages/testing/ECLPasswordTest/ECLPasswordTest"),
);
const ECLMeasureTest = lazy(
   () => import("../../pages/testing/ECLMeasureTest/ECLMeasureTest"),
);
const ECLNumberTest = lazy(
   () => import("../../pages/testing/ECLNumberTest/ECLNumberTest"),
);
const ECLStopLightTest = lazy(
   () => import("../../pages/testing/ECLStopLightTest/ECLStopLightTest"),
);
const ECLGaugeTest = lazy(
   () => import("../../pages/testing/ECLGaugeTest/ECLGaugeTest"),
);
const ECLSelectTest = lazy(
   () => import("../../pages/testing/ECLSelectTest/ECLSelectTest"),
);
const ECLRangeTest = lazy(
   () => import("../../pages/testing/ECLRangeTest/ECLRangeTest"),
);

const testingMenuData = [
   //THIS IS WHERE YOU DEFINE THE ROUTE SLUG,
   //THE LABEL FOR THE TESTING HOMEPAGE, AND THE COMPONENT TO BE TESTED
   {
      domain: "Widgets",
      text: translate("ECLLoader"), //text will appear as header on the page and text in link on TestingPanelHome
      path: "ecl-loader", //sourceone/testing/<path>
      component: <ECLLoaderTest />, // The component goes here
   },
   {
      domain: "Inputs",
      text: translate("ECLDatePicker"),
      path: "ecl-date-picker",
      component: <ECLDatePickerTest />,
   },
   {
      domain: "Inputs",
      text: translate("ECLFileInput"),
      path: "ecl-file-input",
      component: <ECLFileInputTest />,
   },
   {
      domain: "Inputs",
      text: translate("ECLFilterBar"),
      path: "ecl-filter-bar",
      component: <ECLFilterBarTest />,
   },
   {
      domain: "Inputs",
      text: translate("ECLDateTimePicker"),
      path: "ecl-datetime-picker",
      component: <ECLDateTimePickerTest />,
   },
   {
      domain: "Inputs",
      text: translate("ECLTextInput"),
      path: "ecl-text-input",
      component: <ECLTextInputTest />,
   },
   {
      domain: "Widgets",
      text: translate("ECLUserInfo"),
      path: "ecl-user-info",
      component: <ECLUserInfoTest />,
   },
   {
      domain: "Widgets",
      text: translate("ECLFeatureFlag"),
      path: "ecl-feature-flag",
      component: <ECLFeatureFlagTest />,
   },
   {
      domain: "Widgets",
      text: translate("ECLToast"),
      path: "ecl-toast",
      component: <ECLToastTest />,
   },
   {
      domain: "Widgets",
      text: translate("ECLThemeImage"),
      path: "ecl-theme-image",
      component: <ECLThemeImageTest />,
   },
   {
      domain: "Widgets",
      text: translate("ECLRichTextViewer"),
      path: "ecl-richtext-viewer",
      component: <ECLRichTextViewerTest />,
   },
   {
      domain: "Widgets",
      text: translate("ECLTable"),
      path: "ecl-table-test",
      component: <ECLTableTest />,
   },
   {
      domain: "Widgets",
      text: translate("ECLDropDown"),
      path: "ecl-drop-down",
      component: <ECLDropDownTest />,
   },
   {
      domain: "Inputs",
      text: translate("ECLCheckbox"),
      path: "ecl-check-box",
      component: <ECLCheckBoxTest />,
   },
   {
      domain: "Inputs",
      text: translate("ECLSwitch"),
      path: "ecl-switch",
      component: <ECLSwtichTest />,
   },
   {
      domain: "Inputs",
      text: translate("ECLPassword"),
      path: "ecl-password",
      component: <ECLPasswordTest />,
   },
   {
      domain: "Visualizations",
      text: translate("ECLMeasure"),
      path: "ecl-measure",
      component: <ECLMeasureTest />,
   },
   {
      domain: "Visualizations",
      text: translate("ECLStopLight"),
      path: "ecl-stop-light",
      component: <ECLStopLightTest />,
   },
   {
      domain: "Inputs",
      text: translate("ECLNumber"),
      path: "ecl-number",
      component: <ECLNumberTest />,
   },
   {
      domain: "Inputs",
      text: translate("ECLRange"),
      path: "ecl-range",
      component: <ECLRangeTest />,
   },
   {
      domain: "Visualizations",
      text: translate("ECLStopLight"),
      path: "ecl-stop-light",
      component: <ECLStopLightTest />,
   },
   {
      domain: "Visualizations",
      text: translate("ECLGauge"),
      path: "ecl-gauge",
      component: <ECLGaugeTest />,
   },
   {
      domain: "Inputs",
      text: translate("ECLSelect"),
      path: "ecl-select",
      component: <ECLSelectTest />,
   },
];

//DON'T MESS WITH ANYTHING BELOW THIS PROBABLY///////////////////////

const componentRoutes = testingMenuData.map((ele, i) => (
   <Route
      key={`testing-${i + 1}`}
      exact
      path={`/sourceone/testing/${ele.path}`}
      element={<TestLoader title={ele.text}>{ele.component}</TestLoader>}
   />
));

export const testingRoutes = [
   //HOME PAGE
   <Route
      key={`testing-0`}
      exact
      path="/sourceone/testing"
      element={
         <Suspense fallback={<ECLLoader />}>
            <TestingPanelHome data={testingMenuData} />
         </Suspense>
      }
   />,

   //COMPONENT TESTING ROUTES
   ...componentRoutes,
];
